import { useAtomValue } from "jotai";
import { useAuthContext } from "../../../auth/state/AuthContext";
import type { AdminEmailSidebarUnreadProps } from "../../models/admin-email.models";
import { adminEmailMailboxStatusAtom } from "../../state/admin-email.atoms";
import { getAdminEmailUnreadTotal } from "../../utils/admin-email.utils";
import AdminEmailUnreadCount from "./AdminEmailUnreadCount";

// Reuse the sidebar-owned mailbox poll instead of issuing a second request for the navigation capsule.
const AdminEmailSidebarUnread = ({ isCollapsed }: AdminEmailSidebarUnreadProps) => {
  const status = useAtomValue(adminEmailMailboxStatusAtom);
  const accountId = useAuthContext().state.user?.accessToken?.sub;
  const belongsToAccount = Boolean(accountId) && status.accountId === accountId;
  const total = belongsToAccount && status.response ? getAdminEmailUnreadTotal(status.response.mailboxes) : null;
  const error = belongsToAccount ? status.error : null;

  return (
    <span
      data-test="admin-sidebar-emails-unread"
      className={isCollapsed ? "absolute right-0 top-0" : "ml-auto"}
      title={error ?? undefined}
    >
      <AdminEmailUnreadCount count={total} unavailable={Boolean(error)} compact={isCollapsed} />
    </span>
  );
};

export default AdminEmailSidebarUnread;
